import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { errorToast, successToast } from '../../components/toast';
import { plansListAction, razorpayCreateOrderAction, razorpayPaymentSuccessAction } from '../../redux/actions/paymentActions';
import InnerLayout from '../../components/layouts/innerLayout';
import LoaderModal from '../../components/modals/loaderModal';
import RazorpayPayment from '../../components/razorPayPayment';
import { accountDetailsAction } from '../../redux/actions/authAction';

const Subscription = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [plans, setPlans] = useState([]);
    const [orderDetails, setOrderDetails] = useState(null);
    const [storeData, setstoreData] = useState(null)

    // Handle Subscription click
    const handleSubscribe = async (id) => {
        setLoading(true);
        dispatch(
            razorpayCreateOrderAction(
                { plan_id: id },
                onCreateSuccess,
                onError
            )
        );
    };

    // On successful order creation
    const onCreateSuccess = (data) => {
        setLoading(false);
        setOrderDetails(data.data.data.order);  // Store order details to trigger Razorpay payment
        setstoreData(data.data.data.store)
    };

    // On successful payment
    const onPaymentSuccess = (paymentData) => {
        setLoading(true);
        dispatch(
            razorpayPaymentSuccessAction(
                paymentData,
                () => {
                    setLoading(false);
                    fetchAccount();
                    successToast("Payment Successful you can close the payment screen!");
                    navigate('/dashboard'); // Redirect user after payment
                },
                onError
            )
        );
    };

    const fetchAccount = () => {
        setLoading(true)
        dispatch(accountDetailsAction({}, (data) => {
            setstoreData(data.data.data);
            localStorage.setItem('storeData', JSON.stringify(data.data.data));
            setLoading(false);
        }, onError))
    }

    // Fetch Plans
    useEffect(() => {
        setLoading(true);
        dispatch(
            plansListAction(
                {},
                (data) => {
                    setPlans(data.data.data);
                    setLoading(false);
                },
                onError
            )
        );
    }, []);

    const onError = (data) => {
        setLoading(false);
        errorToast(data.data.message);
    };

    return (
        <InnerLayout module={'Subscription'}>
            <div className="h-full p-4 bg-gray-50 md:flex">
                <div className="max-w-7xl mx-auto flex flex-col items-center justify-center">
                    {/* Heading Section */}
                    <div className="text-center mb-12">
                        <h1 className="text-xl md:text-4xl font-bold text-gray-800 mb-4 tracking-wide">
                            Choose Your Subscription Plan
                        </h1>
                        <p className="text-sm md:text-lg text-gray-600">
                            Select a plan that fits your needs and start enjoying our services today!
                        </p>
                    </div>

                    {/* Plans Section */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                        {plans?.map((plan, index) => (
                            <div
                                key={plan?.id}
                                className={`bg-white rounded-xl shadow-lg p-6 border-t-4 ${index % 2 === 0 ? 'border-blue-500' : 'border-green-500'
                                    } transition-transform transform hover:-translate-y-4 hover:shadow-2xl`}
                            >
                                <h2 className="text-2xl font-bold text-gray-800 mb-2">{plan?.name}</h2>
                                <p className="text-xl font-semibold text-primary mb-4">
                                    ₹{plan?.price}
                                </p>
                                <p className="text-gray-500 text-sm mb-6">{plan?.description}</p>
                                <button
                                    onClick={() => handleSubscribe(plan?.id)}
                                    className={`w-full py-3 rounded-lg text-white font-semibold text-lg transition-colors ${loading
                                        ? 'bg-gray-400 cursor-not-allowed'
                                        : 'bg-blue-500 hover:bg-blue-600'
                                        }`}
                                    disabled={loading}
                                >
                                    Subscribe Now
                                </button>
                            </div>
                        ))}
                    </div>

                    {loading && <LoaderModal />}

                    {/* Razorpay Payment Component */}
                    {orderDetails && (
                        <RazorpayPayment
                            storeData={storeData}
                            orderDetails={orderDetails}
                            onPaymentSuccess={onPaymentSuccess}
                        />
                    )}
                </div>
            </div>
        </InnerLayout>
    );
};

export default Subscription;
